import { useEffect, useState } from "react";
import { Baby, Heart, Home, Library, ShoppingBag, User, Users } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Barre principale du bas — demande Julie : Accueil | Mon Instant | Explorer |
// Kids | Boutique | Intervenants | Profil, sur une seule ligne.
export default function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  // La Boutique suit le réglage de Julie (visible tant qu'elle n'est pas désactivée)
  const [shopEnabled, setShopEnabled] = useState(true);

  useEffect(() => {
    axios
      .get(`${API}/settings/public`)
      .then(({ data }) => setShopEnabled(data.shop_enabled !== false))
      .catch(() => {});
  }, []);

  const ITEMS = [
    { id: "accueil", label: "Accueil", Icon: Home, path: "/accueil" },
    { id: "mon-instant", label: "Mon Instant", Icon: Heart, path: "/mon-instant" },
    { id: "explorer", label: "À la carte", Icon: Library, path: "/explorer" },
    { id: "kids", label: "Kids", Icon: Baby, path: "/kids" },
    ...(shopEnabled ? [{ id: "boutique", label: "Boutique", Icon: ShoppingBag, path: "/boutique" }] : []),
    { id: "intervenants", label: "Intervenants", Icon: Users, path: "/intervenants" },
    { id: "profil", label: "Profil", Icon: User, path: "/profil" },
  ];

  // Bandeau réservé aux personnes connectées
  if (!localStorage.getItem("rav-token")) return null;
  return (
    <nav className="rav-nav rav-nav-seven" data-testid="bottom-nav">
      {ITEMS.map(({ id, label, Icon, path }) => {
        const active = path ? location.pathname === path : false;
        return (
          <button
            key={id}
            type="button"
            data-testid={`nav-${id}`}
            className={`rav-nav-item${active ? " is-active" : ""}`}
            aria-current={active ? "page" : undefined}
            onClick={() => navigate(path)}
          >
            <Icon size={20} strokeWidth={1.5} />
            <span>{label}</span>
          </button>
        );
      })}
    </nav>
  );
}
